module.exports = __webpack_public_path__ + "static/insert_legend_1-db89815d09b3ca743b37a9b24c1b5e5a.png";